// Environment settings for the application
export const environment = {
  baseUrl: 'https://syncedapi.azurewebsites.net/',
  debug: false,
  // baseUrl: 'https://syncedtestingapi.azurewebsites.net/'B
  // baseUrl: 'http://localhost:51016/'
};

// "Sign in with Xero" needs no settings here. The add-in's dialog opens xero-signin.html, and the
// API builds the Xero link with its own client id and callback (api/Account/XeroSignInExcel), so
// the two can not drift apart. They had: this file used to carry a different Xero app's client id
// and the testing API's callback.
